export const getHeatmapConfigHumidity = (name, radius = 20) => {
  return {
    id: "nu4hi1x",
    type: "heatmap",
    config: {
      dataId: "humidity",
      label: "point",
      color: [114, 12, 157],
      highlightColor: [252, 242, 26, 255],
      columns: {
        lat: "lat",
        lng: "lon",
      },
      isVisible: true,
      visConfig: {
        opacity: 0.8,
        colorRange: {
          name: "ColorBrewer RdPu-6",
          type: "sequential",
          category: "ColorBrewer",
          colors: [
            "#eff3ff",
            "#c6dbef",
            "#9ecae1",
            "#6baed6",
            "#3182bd",
            "#08519c",
          ],
        },
        radius: radius,
      },
      hidden: false,
      weightField: {
        name: name,
        type: "real",
      },
      textLabel: [
        {
          field: null,
          color: [255, 255, 255],
          size: 18,
          offset: [0, 0],
          anchor: "start",
          alignment: "center",
        },
      ],
    },
    visualChannels: {
      weightField: {
        name: name,
        type: "real",
      },
      weightScale: "linear",
    },
  };
};

export const getHeatmapConfigHumidityNorm = (name, radius = 25) => {
  return {
    id: "nu4hi1x",
    type: "heatmap",
    config: {
      dataId: "humidity",
      label: "point",
      color: [114, 12, 157],
      highlightColor: [252, 242, 26, 255],
      columns: {
        lat: "lat",
        lng: "lon",
      },
      isVisible: true,
      visConfig: {
        opacity: 0.8,
        colorRange: {
          name: "ColorBrewer RdPu-6",
          type: "sequential",
          category: "ColorBrewer",
          colors: [
            "#eff3ff",
            "#c6dbef",
            "#9ecae1",
            "#6baed6",
            "#3182bd",
            "#08519c",
          ],
        },
        radius: radius,
      },
      hidden: false,
      weightField: {
        name: 'data_norm',
        type: "real",
      },
      textLabel: [
        {
          field: null,
          color: [255, 255, 255],
          size: 18,
          offset: [0, 0],
          anchor: "start",
          alignment: "center",
        },
      ],
    },
    visualChannels: {
      weightField: {
        name: 'data_norm',
        type: "real",
      },
      weightScale: "linear",
    },
  };
};